var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurgerClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    d: "M4.3 4.3l11.4 11.4M4.3 15.7L15.7 4.3"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0idGlueSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPg0KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMyRDJEMkQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTQuMyA0LjNsMTEuNCAxMS40TTQuMyAxNS43TDE1LjcgNC4zIi8+DQo8L3N2Zz4NCg==";
export { SvgBurgerClose as ReactComponent };